import { render, staticRenderFns } from "./HomeEventBlock.vue?vue&type=template&id=5b3dd901&scoped=true&"
import script from "./HomeEventBlock.vue?vue&type=script&lang=js&"
export * from "./HomeEventBlock.vue?vue&type=script&lang=js&"
import style0 from "./HomeEventBlock.vue?vue&type=style&index=0&id=5b3dd901&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3dd901",
  null
  
)

export default component.exports